<section class="sidebar h-full w-[248px]">
  <div class="flex h-full flex-col justify-between rounded-3xl bg-white px-4 py-8">
    <div>
      <figure class="mb-10">
        <img src="assets/images/logos/zhongguo.svg" />
      </figure>
      <div class="mb-10 w-full">
        <a
          routerLink="/remit"
          app-button
          class="block w-full text-center transition-all hover:bg-primary-800"
          translate>
          btn.createTransaction
        </a>
      </div>
      <div class="sidebar-navs">
        <ul class="flex flex-col gap-6">
          <ng-container *ngFor="let nav of navList">
            <a
              draggable="false"
              #activeNav="routerLinkActive"
              class="relative flex items-center text-neutral-500"
              [routerLink]="nav.link"
              routerLinkActive="text-neutral-900 font-medium">
              <app-icon [name]="activeNav.isActive ? nav.iconActive : nav.icon"> </app-icon>
              <p
                *ngIf="activeNav.isActive"
                class="absolute bottom-[-6px] left-1.5 h-0.5 w-3 rounded-md bg-primary-600"></p>
              <p class="ml-4" translate>
                {{ "menu." + nav.name }}
              </p>
            </a>
          </ng-container>
        </ul>
      </div>
    </div>
    <div class="relative">
      <button (click)="showMultiLanguage = !showMultiLanguage" class="mb-6 flex items-center">
        <figure class="mr-1 h-6 w-6 overflow-hidden">
          <app-flag name="{{ languageService.currentLanguage?.icon }}"></app-flag>
        </figure>
        <p class="prose prose-text-sm ml-4 font-medium">
          {{ languageService.currentLanguage?.name }}
        </p>
      </button>

      <div
        *ngIf="showMultiLanguage"
        class="popup-select-language shadow-custom absolute z-10 w-[140px] rounded-2xl border border-neutral-100 bg-white px-4 py-3 text-sm md:left-[115px] md:top-[-27px]">
        <ng-container *ngFor="let language of languageService.languages; index as i">
          <button
            class="flex items-center w-full {{
              i < languageService.languages.length - 1 ? 'pb-2' : ''
            }}"
            (click)="switchLanguage(language.lang)">
            <app-flag name="{{ language.icon }}" fontSize="24px"></app-flag>
            <h3 class="pl-4 font-semibold">{{ language.name }}</h3>
          </button>
          <hr *ngIf="i < languageService.languages.length - 1" class="pt-2 text-neutral-100" />
        </ng-container>
        <div data-popper-arrow></div>
      </div>

      <a class="mb-6 flex cursor-pointer items-center" (click)="logout()">
        <figure class="h-6 w-6 overflow-hidden">
          <app-icon name="log-out"></app-icon>
        </figure>
        <p class="prose prose-text-sm ml-4 font-medium" translate>btn.log_out</p>
      </a>
      <div class="mb-6 h-[1px] w-full bg-neutral-200"></div>
      <div class="flex flex-col gap-4">
        <div class="flex items-center gap-3">
          <div class="cursor-pointer">
            <img alt="App Store" src="assets/images/app-store.svg" />
          </div>
          <div class="cursor-pointer">
            <img alt="Google Play" src="assets/images/google-play.svg" />
          </div>
        </div>
        <a class="text-sm font-medium text-blue-500 underline" routerLink="/account/t&c" translate
          >lbl.termAndConditions</a
        >
        <a
          class="text-sm font-medium text-blue-500 underline"
          routerLink="/account/privacy"
          translate
          >lbl.privacyPolicy</a
        >
        <p class="text-sm font-regular text-neutral-500" translate>lbl.copyright_web_line-1</p>
        <p class="text-sm font-regular text-neutral-500" translate>lbl.copyright_web_line-2</p>
      </div>
    </div>
  </div>
</section>
